
import store from "../store"

import {
    setWorldState,
} from "./index.js"

import {
    stopSpeechKeyboard,
    setFinalResult,
} from "./microphone.js"

export const addLetter = (code) => {

    const sym = String.fromCharCode(code)

    return {
        type: "KEYBOARD_ADD",
        symbol: sym,
    }
}

export const clearKeyboard = () => {

    return {
        type: "KEYBOARD_CLEAR",
    }
}

export const backspace = () => {
    return {
        type: "KEYBOARD_BACKSPACE"
    }
}

export const sendWord = (word, searchType) => {

    return function (dispatch) {

        dispatch( setFinalResult(word) )

        return {
            type: "KEYBOARD_SUBMIT",
            result: word,
            searchType: searchType,
        }
    }

}

const onKeyPress = (e) => {

    return (dispatch, getState) => {

        const {worldView, searchType} = getState().globalState
        const keyboard = getState().keyboard

        if (worldView !== "WORLD_KEYBOARD" && worldView !== "WORLD_HUD") {

            switch (worldView) {
                case "WORLD_INPUT":
                    dispatch( stopSpeechKeyboard() )
                break;
            }
            dispatch(clearKeyboard())
            dispatch(setWorldState("WORLD_KEYBOARD"))
        }
    
        if (e.keyCode === 13) {
            dispatch(sendWord(keyboard.text, searchType))
            return 
        }
    
        dispatch(addLetter(e.keyCode))
    }

    
}

const onKeyDown = (e) => {

    return (dispatch) => {
        if (e.keyCode === 8) {
            dispatch(backspace())
        }
    }
}

document.addEventListener("keypress", (e) => {
    store.dispatch(onKeyPress(e))
})
document.addEventListener("keydown", (e) => {
    store.dispatch(onKeyDown(e))
})


// WEBPACK FOOTER //
// ./src/actions/keyboard.js